import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const ADMIN_PERMISSION_ID = 'c410528e-9804-4591-bb7e-be1cc58774de';
const MANAGER_PERMISSION_ID = 'f5cdb99f-fc87-47de-a53d-f46d4b1ef173';
const GUEST_PERMISSION_ID = '469541de-8507-41ad-98b2-952977a61fdb';

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); 

  useEffect(() => {
    const storedUser = localStorage.getItem('user');

    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem('user');
        setUser(null);
      }
    } else {
      setUser(null);
    }
  }, []);

  const login = (userData) => {
    const userWithPermission = {
      ...userData,
      user_permission_id: userData.user_permission_id || null
    };

    setUser(userWithPermission);
    localStorage.setItem('user', JSON.stringify(userWithPermission));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const isAdmin = () => {
    return user?.user_permission_id === ADMIN_PERMISSION_ID;
  };

  // Admin também conta como Manager
  const isManager = () => {
    return (
      user?.user_permission_id === MANAGER_PERMISSION_ID ||
      user?.user_permission_id === ADMIN_PERMISSION_ID
    );
  };

  const isGuest = () => {
    return user?.user_permission_id === GUEST_PERMISSION_ID;
  };

  const isRestrictedUser = isGuest();

  const loading = user === undefined;

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading,
      login, 
      logout,
      isAdmin,
      isManager,
      isGuest,
      isRestrictedUser
    }}>
      {children}
    </AuthContext.Provider>
  );
}